(function() { window.GUID_80a16791_47dc_416a_b109_42e90c7a9700 = { getGuid: function() { return "80a16791-47dc-416a-b109-42e90c7a9700"; } }; })();
var CS;
(function (CS) {
    class GlobalConst {
        constructor(jsonData) {
            let data = JSON.parse(jsonData);
            GlobalConst.FacebookAppKey = data.FacebookAppKey;
            GlobalConst.PictureSizes = data.PictureSizes;
            GlobalConst.ForceFullNavigation = data.ForceFullNavigation;
            GlobalConst.EnableSignalR = data.EnableSignalR;
            GlobalConst.EnableGoogleAnalytics = data.EnableGoogleAnalytics;
            GlobalConst.UseInfolinksAds = data.UseInfolinksAds;
            GlobalConst.UseGoogleAdsense = data.UseGoogleAdsense;
            GlobalConst.UseEzoicAds = data.UseEzoicAds;
        }
    }
    CS.GlobalConst = GlobalConst;
})(CS || (CS = {}));

//# sourceMappingURL=cs-globalconst.js.map
